import { Describe, is, string } from 'superstruct';

export const SvgValidator: Describe<string> = string();
export const isSvg = (obj: unknown) => is(obj, SvgValidator);
